import { Component, Input } from '@angular/core';
import { License } from 'app/shared/models/license';

@Component({
  selector: 'app-license-details-general',
  templateUrl: './license-details-general.component.html',
})
export class LicenseDetailsGeneralComponent {
  @Input() item: License;
}
